module.exports = __webpack_public_path__ + "img/btn_webtoon.6202d8cf.png";